<div class="disabled-page">
  <mat-card appearance="outlined" class="disabled-card">
    <mat-card-content>
      <h2>This page is not available</h2>
      <p>
        The <strong>{{ pageKey }}</strong> feature is currently disabled for
        this project.
      </p>
    </mat-card-content>
  </mat-card>
</div>
